<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="isActive ? $t('chords.hideTooltip') : $t('chords.showTooltip')"
        :active="isActive"
        @menuClick="toggleChordDiagrams()">
        <svg class="size-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="2" stroke-width="2"/>
            <line x1="3" y1="8" x2="21" y2="8" stroke-width="1.5"/>
            <line x1="8" y1="8" x2="8" y2="21" stroke-width="1.5"/>
            <line x1="13" y1="8" x2="13" y2="21" stroke-width="1.5"/>
            <line x1="18" y1="8" x2="18" y2="21" stroke-width="1.5"/>
            <circle cx="8" cy="13" r="2" fill="currentColor" stroke="none"/>
            <circle cx="13" cy="11" r="2" fill="currentColor" stroke="none"/>
        </svg>
    </MenuBase>
</template>
<script setup>
import { ref, defineProps } from 'vue'
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { appEvents } from '@/store/app.events';

const props = defineProps({
    disabled: { type: Boolean, default: true },
    hidden: { type: Boolean, default: true },
    tooltipPosition: { type: String, default: 'top' },
    active: { type: Boolean, default: false },
    theme: { type: String, default: 'light' },
})

const isActive = ref(props.active)

const toggleChordDiagrams = () => {
    isActive.value = !isActive.value
    appEvents.emit('toggleChordDiagrams', isActive.value)
}

appEvents.on('currentChordDiagramsVisibility', (value) => {
    isActive.value = value
})
</script>
